<ng-container *ngIf="!view3DModel; else show3DModel">
  <div class="text-center position-relative w-100" *ngIf="images?.length || videos?.length; else noimage">
    <ng-container *ngIf="(images || []) as images; else noimage">
      <div class="text-center" [ngClass]="{'w-100': w100, 'h-100': h100}">
        <ngb-carousel
          #myCarousel
          [interval]="-1"
          [showNavigationIndicators]="!!minimal && (images.length + videos.length) > 1"
          [showNavigationArrows]="(!!minimal || !!showNavigationArrows) && (images.length + videos.length) > 1"
          [ngClass]="{'w-100': w100, 'h-100': h100}"
        >
          <ng-template ngbSlide *ngFor="let image of images; let i = index" [id]="imageIdString + i">
            <div class="square" [ngClass]="{'w-100': w100, 'h-100': h100}">
              <div class="content carousel-main-image" [ngClass]="{'w-100': w100, 'h-100': h100}">
                <div class="d-flex justify-content-center align-items-flex-start" *ngIf="zoom">
                  <lib-ngx-image-zoom
                    class="img-fluid"
                    [thumbImage]="image.extra._isGif
                      ? ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl)
                      : ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl
                          :'type:detail'
                          :'size:'+imageSize
                          :'format:'+imageFormat
                          :'etag:'+image.s3ETag
                          :'fill:'+imageColorFill
                          :'background_color:'+imageBackgroundColor
                          :'orientation:'+orientation)"
                    [fullImage]="image.extra._isGif
                      ? ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl)
                      : ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl
                          :'type:high'
                          :'size:'+imageSizeZoom
                          :'format:'+imageFormat
                          :'etag:'+image.s3ETag
                          :'fill:'+imageColorFill
                          :'background_color:'+imageBackgroundColor
                          :'orientation:'+orientation)"
                  >
                  </lib-ngx-image-zoom>
                </div>
                <div *ngIf="!zoom" [ngClass]="{'w-100': w100, 'h-100': h100}">
                  <ng-container *ngIf="!openExternal; else externalImage">
                    <img
                      *ngIf="!enableFullImage"
                      class="img-fluid mx-auto d-block mw-100"
                      [class.cursor-pointer]="openInternal"
                      [ngStyle]="{
                        'max-width.px': highRes ? imageMaxWidth : '',
                        'max-height.px': highRes ? imageMaxHeight : ''
                      }"
                      [src]="image.extra._isGif
                        ? ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl)
                        : ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl
                            :'type:detail'
                            :'size:'+imageSize
                            :'format:'+imageFormat
                            :'etag:'+image.s3ETag
                            :'fill:'+imageColorFill
                            :'background_color:'+imageBackgroundColor
                            :'orientation:'+orientation)"
                      alt="{{ image.description }}"
                      (click)="openInternal ? openImageModal(image) : undefined"
                    />
                    <img
                      *ngIf="enableFullImage"
                      class="img-fluid mx-auto d-block"
                      [ngStyle]="{
                        'max-width.px': highRes ? imageMaxWidth : '',
                        'max-height.px': highRes ? imageMaxHeight : ''
                      }"
                      [src]="(image.extra.s3UriEncoded || image.s3Uri) | gungImageUrl"
                      alt="{{ image.description }}"
                    />
                  </ng-container>

                  <ng-template #externalImage>
                    <a
                      [href]="image.extra._isGif
                        ? ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl)
                        : ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl
                            :'type:high'
                            :'size:'+imageSizeZoom
                            :'format:'+imageFormat
                            :'etag:'+image.s3ETag
                            :'fill:'+imageColorFill
                            :'background_color:'+imageBackgroundColor
                            :'orientation:'+orientation)"
                      target="_blank"
                    >
                      <img
                        class="img-fluid mx-auto d-block mw-100"
                        [ngStyle]="{
                          'width.px': highRes ? imageMaxWidth : '',
                          'max-height.px': highRes ? imageMaxHeight : ''
                        }"
                        [src]="image.extra._isGif
                        ? ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl)
                        : ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl
                            :'type:detail'
                            :'size:'+imageSize
                            :'format:'+imageFormat
                            :'etag:'+image.s3ETag
                            :'fill:'+imageColorFill
                            :'background_color:'+imageBackgroundColor
                            :'orientation:'+orientation)"
                        alt="{{ image.description }}"
                      />
                    </a>
                  </ng-template>
                </div>
                <div class="d-flex justify-content-center align-items-flex-start open-images" *ngIf="openExternal" [ngClass]="{'position-absolute bottom-0 end-50': w100 || h100}">
                  <a
                    [href]="image.extra._isGif
                      ? ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl)
                      : ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl
                          :'type:high'
                          :'size:'+imageSizeZoom
                          :'format:'+imageFormat
                          :'etag:'+image.s3ETag
                          :'fill:'+imageColorFill
                          :'background_color:'+imageBackgroundColor
                          :'orientation:'+orientation)"
                    target="_blank"
                    class="btn btn-light"
                  >
                    <i class="fas fa-search-plus d-block"></i>
                  </a>
                </div>
                <div class="d-flex justify-content-center align-items-flex-start open-images" *ngIf="openInternal" [ngClass]="{'position-absolute bottom-0 end-50': w100 || h100}">
                  <a (click)="openImageModal(image)" class="btn btn-light">
                    <i class="fas fa-search-plus d-block"></i>
                  </a>
                </div>
              </div>
            </div>
          </ng-template>
          <!-- VIDEO -->
          <ng-template #videoSlide *ngFor="let video of videos; let i = index" ngbSlide [id]="imageIdString + (images.length + i)">
            <ng-template #videoYoutube [ngIf]="video.provider === 'youtube'">
              <iframe
                [id]="imageIdString + (images.length + i)"
                width="100%"
                height="315"
                [src]="video.embed"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </ng-template>
            <ng-template #videoVimeo [ngIf]="video.provider === 'vimeo'">
              <div style="padding: 56.25% 0 0 0; position: relative">
                <iframe
                  [id]="imageIdString + (images.length + i)"
                  [src]="video.embed"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
                  frameborder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowfullscreen
                >
                </iframe>
              </div>
              <script src="https://player.vimeo.com/api/player.js"></script>
            </ng-template>
            <ng-template #videoDirect [ngIf]="video.provider === 'direct'">
              <div [innerHtml]="video.embed | safeHtml"></div>
            </ng-template>
            <ng-template #videoPimVideo [ngIf]="video.provider === 'pim-video'">
              <div class="square">
                <div class="content carousel-main-image pim-video-slide d-flex justify-content-center align-items-center">
                  <video
                    [id]="imageIdString + (images.length + i)"
                    class="d-block"
                    preload="metadata"
                    controls
                    playsinline
                    [src]="video.url | gungDownloadUrl"
                  ></video>
                </div>
              </div>
            </ng-template>
          </ng-template>
        </ngb-carousel>
      </div>
    </ng-container>

    <div class="images-options position-absolute">
      <div
        class="scrolling-images"
        [style.width.px]="scrollingContainerWidth"
        style="padding: 6px; border-radius: 8px; overflow: hidden;"
      >
        <div
          class="d-flex flex-row flex-nowrap"
          #scrollContainer
          style="transition: scroll-left 0.3s ease-in-out; overflow-x: hidden; width: max-content;"
        >
          <div
            class="me-2"
            *ngFor="let image of images; let i = index"
            (click)="select(i)"
            style="cursor: pointer; flex: 0 0 auto;"
          >
            <img
              class="border"
              [ngClass]="{'border-primary': i === lastCarouselSelectedIndex}"
              style="width: 60px; height: 60px; object-fit: cover;"
              [src]="image.extra._isGif
                ? ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl)
                : ((image.extra?.s3UriEncoded || image.s3Uri) | gungImageUrl
                    :'type:thumbnail'
                    :'format:'+imageFormat
                    :'size:'+imageSizeThumbnail
                    :'etag:'+image.s3ETag
                    :'fill:'+imageColorFill
                    :'background_color:'+imageBackgroundColor
                    :'orientation:'+orientation)"
              alt="{{ image.description }}"
            />
          </div>
          <div
            class="me-2 pim-video-thumb-wrapper"
            *ngFor="let video of videos; let i = index"
            [hidden]="video.provider !== 'pim-video'"
            (click)="select(images.length + i)"
            style="cursor: pointer; flex: 0 0 auto; position: relative;"
          >
            <video
              class="border pim-video-thumb"
              [ngClass]="{'border-primary': (images.length + i) === lastCarouselSelectedIndex}"
              style="width: 60px; height: 60px; object-fit: cover; display: block;"
              preload="metadata"
              muted
              playsinline
              [src]="video.url | gungDownloadUrl"
            ></video>
            <span class="pim-video-thumb-play-overlay">
              <i class="fas fa-play"></i>
            </span>
          </div>
        </div>
      </div>

      <div class="select-btns">
        <button
          class="btn btn-light"
          (click)="selectPrevious()"
        >
          <i class="fa fa-caret-left"></i>
        </button>

        <button
          class="btn btn-light"
          (click)="selectNext()"
        >
          <i class="fa fa-caret-right"></i>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="model3dFile?.length" class="col-12 d-flex justify-content-center mt-2">
    <a (click)="view3DModel = !view3DModel" class="d-flex align-items-center" translate>
      <i class="fab fa-unity fa-2x"></i>&nbsp;<span translate>VIEW_PRODUCT_AS_3D_MODEL</span>
    </a>
  </div>
</ng-container>

<ng-template #show3DModel>
  <div class="row">
    <div class="col-12 mb-2 text-center">
      <lib-gung-viewer3d-wrapper
        [modelFile]="model3dFile"
        width="100%"
        height="400px"
        [initLoad]="true"
      ></lib-gung-viewer3d-wrapper>
    </div>
    <div class="col-12 d-flex justify-content-center">
      <a (click)="view3DModel = !view3DModel" class="d-flex align-items-center" translate>
        <i class="fa-solid fa-images fa-lg"></i>&nbsp;<span translate>VIEW_PRODUCT_IMAGES</span>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #noimage>
  <img
    class="img-fluid w-100 mx-auto d-block"
    [src]="'images/no-image.jpg' | gungImageUrl"
    alt="NO IMAGE"
  />
</ng-template>
